<template>
    <div>
        <div class="header mt-5">
            {{ $vuetify.lang.t('$vuetify.timeTableSetting.header')}}
        </div>

        <nav-bar
            ref="navbar"
            @menu-change="menuChange"
            :menuItem="navbarList" />

        <component :is="component" />
    </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import SpecialWorkday from '@/components/TimeTableSetting/SpecialWorkday.vue'
import Workday from '@/components/TimeTableSetting/Workday.vue'
import Holiday from '@/components/TimeTableSetting/Holiday.vue'

export default {
    name: 'TimeTableSetting',

    components: {
        NavBar,
        SpecialWorkday,
        Workday,
        Holiday
    },

    data () {
        return {
            component: '',
            userPermissions: [],
            menuItem: [
                {
                    title: this.$vuetify.lang.t('$vuetify.timeTableSetting.workday'),
                    path: 'Workday',
                    pathName: 'workday',
                    permission: []
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.timeTableSetting.specialWorkday'),
                    path: 'SpecialWorkday',
                    pathName: 'special-workday',
                    permission: []
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.timeTableSetting.holiday'),
                    path: 'Holiday',
                    pathName: 'holiday',
                    permission: []
                }
            ],
            mappedTranslation: {
                Workday: 'workday',
                SpecialWorkday: 'specialWorkday',
                Holiday: 'holiday'
            }
        }
    },

    computed: {
        navbarList () {
            const navbar = []
            for (const item of this.menuItem) {
                navbar.push(item)
            }
            return navbar
        }
    },

    methods: {

        setLangNavBar () {
            for (let i = 0; i < this.menuItem.length; i++) {
                if (this.mappedTranslation[this.menuItem[i].path]) {
                    this.menuItem[i].title = this.$vuetify.lang.t(`$vuetify.timeTableSetting.${this.mappedTranslation[this.menuItem[i].path]}`)
                }
            }
        },

        menuChange (payload) {
            this.component = payload.path

            const path = `/time-table-setting/${this.navbarList[payload.index].pathName}`
            if (this.$route.path !== path) {
                this.$router.replace(path)
            }
        },

        navbarPermission () {
            this.component = this.navbarList[0].path
        },

        setActive (path) {
            let index = 0
            if (path === 'TimeTableSetting') {
                this.$refs.navbar.go(this.navbarList[0].pathName, index)
            } else {
                index = this.navbarList.findIndex(x => x.path === path)
                this.$refs.navbar.go(path, index)
            }

            const directPath = `/time-table-setting/${this.navbarList[index].pathName}`
            if (this.$route.path !== directPath) {
                this.$router.replace(directPath)
            }
        }
    },

    mounted () {
        this.userPermissions = this.$store.state.permissions
        this.navbarPermission()
        this.setActive(this.$router.currentRoute.name)
    },

    watch: {
        '$vuetify.lang.current': {
            handler: function (after, before) {
                this.setLangNavBar()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    display: flex;
    justify-content: space-between;
    font-size: 28px;
    font-weight: bold;
}
</style>
